<template>
  <div class="dashBoadr">
    <!-- 仪表盘上部数据部分 -->
    <div class="studyData_top">
      <div class="infoOne topInfo">
        <div class="info_title">最近学习</div>
        <div class="info_number">
          <span class="size24">{{ myDashBoadr.min }}</span>
          <span class="hui">分钟</span>
        </div>
      </div>
      <div class="heng"></div>
      <div class="infoTwo topInfo">
        <div class="info_title">行动力超过</div>
        <div class="info_number">
          <span class="size24">{{ myDashBoadr.action_rate }}%</span>
          <span class="hui">同学</span>
        </div>
      </div>
      <div class="heng"></div>
      <div class="infoThree topInfo">
        <div class="info_title">累计打卡</div>
        <div class="info_number">
          <span class="size24">{{ myDashBoadr.login_days }}</span>
          <span class="hui">天</span>
        </div>
      </div>
    </div>
    <!-- 仪表盘中部圆形进度条部分 -->
    <!-- <div class="studyData_center">
      <div ref="init">
        <yuan
          :id="1"
          :width="yuanHeight"
          :radius="yuanHeight / 10"
          :progress="myDashBoadr.learn_rate"
          :delay="200"
          :duration="1000"
          :barColor="'#FF8673'"
          :backgroundColor="'#EDEDED'"
          :isAnimation="false"
        >
          <template slot="top">
            <div class="number">{{ myDashBoadr.learn_rate }}%</div>
            <div class="text">学习进度</div>
          </template>
        </yuan>
      </div>
    </div> -->
    <div class="studyData_bottom">
      <Calendar :markDateMore="makeDate"></Calendar>
      <!--  :markDate="myDashBoadr.sign_date" -->
      <!-- <Calendar
        v-on:choseDay="clickDay"
        v-on:changeMonth="changeDate"
        :markDate="myDashBoadr.sign_date"
      ></Calendar> -->
    </div>
  </div>
</template>

<script>
// import yuan from "@/components/detail_child/circle-progress.vue";
import Calendar from "@/components/detail_child/calendar.vue";
export default {
  name: "dashBoadr",
  props: {
    myDashBoadr: {
      type: Object,
      default: () => {
        return {
          sign_date: [
            //「已打卡天数」
            "2021-08-14",
            "2021-08-18",
          ],
          min: 0, //「学习时长、分钟」
          action_rate: 40, //「行动力百分比」
          login_days: 1, //「累计登录天数」这个暂时写的死数据、待定、
          learn_rate: 39, //「学习进度」
        };
      },
    },
  },
  data() {
    return {
      // 这个数组用来传递打卡成功之后的标记天数
      arr: ["2021-08-14", "2021-08-18"],
      test: 20,
      yuanHeight: 200,
    };
  },
  components: {
    // yuan,
    Calendar,
  },
  methods: {
    // clickDay(data) {
    //   console.log(data); //选中某天
    // },
    // changeDate(data) {
    //   console.log(data); //左右点击切换月份
    // },
  },
  computed: {
    // 返回已打卡天数，去除Null值的时候报错
    makeDate(){
      var myDate = []
       if (this.myDashBoadr.date_range == null) {
        myDate = [];
      } else {
        this.myDashBoadr.date_range.forEach((item) => {
          myDate.push({ date: item, className: "noCard" });
        });
      }

      if(this.myDashBoadr.sign_date == null){
        return myDate
      }else{
        this.myDashBoadr.sign_date.forEach((item) => {
          myDate.push({ date: item, className: "wh_isMark" });
        });
      }
      return myDate
    }
  },
  mounted() {
    // // 动态设置圆形进度条大小
    // this.yuanHeight = this.$refs.init.offsetHeight;
    // //  实时监控浏览器窗口变化并动态设置大小
    // window.onresize = () => {
    //   if (this.$refs) {
    //     this.yuanHeight = this.$refs.init.offsetHeight;
    //   }
    // };
  },
};
</script>

<style lang="less" scoped>
.dashBoadr {
  width: 100%;
  height: 100%;
  //   仪表盘上部数据部分
  .studyData_top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 6.125rem;
    border-bottom: 0.0625rem solid #f4f4f4;
    .heng {
      width: 0.0625rem;
      height: 2.25rem;
      background: #eeeeee;
    }
    .topInfo {
      flex: 1;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      .info_title {
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        color: #757c82;
      }
      .info_number {
        margin-top: 1rem;
        .size24 {
          font-size: 1.5rem;
          color: #ff8673;
        }
        .hui {
          font-size: 0.75rem;
          color: #757c82;
        }
      }
    }
  }
  //   仪表盘中部圆形进度条部分
  .studyData_center {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 16.25rem;
    width: 100%;
    border-bottom: 0.0625rem solid #f4f4f4;
    .number {
      font-size: 2.5rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #ff8673;
    }
    .text {
      font-size: 1rem;
      font-family: " Microsoft YaHei";
      font-weight: 400;
      color: #aaadb2;
    }
  }
  //   仪表盘下部日历签到部分
  .studyData_bottom {
    width: 100%;
    height: auto;
    /deep/ .el-calendar {
      .el-calendar__header {
      }
    }
  }
}
</style>